import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FileText, ChevronDown, Presentation, Eye } from "lucide-react";

interface Props {
  onPreviewPdf: () => void;
  onGeneratePdf: () => void;
  onGeneratePpt: () => void;
  disabled?: boolean;
}

export function GenerateReportDropdown({
  onPreviewPdf,
  onGeneratePdf,
  onGeneratePpt,
  disabled,
}: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled}>
          <FileText className="h-4 w-4 mr-1.5" />
          Generate Report
          <ChevronDown className="h-3.5 w-3.5 ml-1.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onPreviewPdf}>
          <Eye className="h-4 w-4 mr-2" />
          Preview Report
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onGeneratePdf}>
          <FileText className="h-4 w-4 mr-2" />
          Download PDF Report
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onGeneratePpt}>
          <Presentation className="h-4 w-4 mr-2" />
          Download PPT Report
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
